import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { CONTRACTS } from '../contracts/addresses';
import { VAULT_ABI, ERC20_ABI } from '../contracts/abis';

function VaultStats({ provider, account, refreshKey }) {
  const [stats, setStats] = useState({
    yourBalance: '0',
    profit: '0',
    walletBalance: '0',
    tvl: '0'
  });
  const [loading, setLoading] = useState(true);

  const loadStats = async () => {
    if (!provider || !account) return;
    
    try {
      setLoading(true);
      const vault = new ethers.Contract(CONTRACTS.vault, VAULT_ABI, provider);
      const usdc = new ethers.Contract(CONTRACTS.usdc, ERC20_ABI, provider);

      const [totalAssets, shares, usdcBal] = await Promise.all([
        vault.totalAssets(),
        vault.balanceOf(account),
        usdc.balanceOf(account)
      ]);

      const yourValue = shares.gt(0) 
        ? await vault.convertToAssets(shares)
        : ethers.BigNumber.from(0);

      // Profit = current value - shares (since shares minted 1:1)
      const profit = yourValue.sub(shares);

      setStats({
        yourBalance: ethers.utils.formatUnits(yourValue, 6),
        profit: ethers.utils.formatUnits(profit, 6),
        walletBalance: ethers.utils.formatUnits(usdcBal, 6),
        tvl: ethers.utils.formatUnits(totalAssets, 6)
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, [provider, account, refreshKey]);

  if (loading) {
    return (
      <div className="stats">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  const profit = parseFloat(stats.profit);
  const hasProfit = profit > 0;

  return (
    <div className="stats">
      <div className="stat-row">
        <div className="stat-main">
          <div className="stat-label">Your Balance</div>
          <div className="stat-value-large">
            ${parseFloat(stats.yourBalance).toFixed(2)}
          </div>
          {hasProfit && (
            <div className="stat-profit">
              +${profit.toFixed(4)} profit
            </div>
          )}
        </div>
        
        <div className="stat-secondary">
          <div className="stat-item">
            <div className="stat-label">Wallet</div>
            <div className="stat-value">${parseFloat(stats.walletBalance).toFixed(2)}</div>
          </div>
          <div className="stat-item">
            <div className="stat-label">Total Locked</div>
            <div className="stat-value">${parseFloat(stats.tvl).toFixed(2)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VaultStats;